<router-outlet></router-outlet>
<loading-indicator class="overlay" [isVisible]="globalLoader.active$ | async"></loading-indicator>
